/*
  Type    |       QA              |       QA2             |       RFS             |       PROD
-----------------------------------------------------------------------------------------------------------------
Type - 1  |  qa1.monsterindia     |  qa2.monsterindia     |  rfs.monsterindia     |  backendservices.monsterindia.com
Type - 2  |  qa1.monsterindia     |  qa2.monsterindia     |  rfs.monsterindia     |  apiv2.monsterindia.com
*/

export const ENV = {
  qa1: {
    regions: {
      india: {
        api_url: "https://qa1.foundit.in",
        api_t_1: "https://qa1.monsterindia.com",
        api_t_2: "https://qa1.monsterindia.com",
        api_t_3: "https://qa1.monsterindia.com",
        site_map: "rexmonster",
        domain: "qa1.foundit.in",
        media_url: "media.foundit.in",
        region: "india",
        gtm_id: "GTM-NGL6ZM",
        country_code: "IN",
        country_isd_code: "91",
        country_id: "110",
        currency_code: "INR",
        currency_id: "4",
        currency_name: "Indian Rupees",
        currency_sign: "₹",
      },
      gulf: {
        api_url: "https://qa1.founditgulf.com",
        api_t_1: "https://qa1.monsterindia.com",
        api_t_2: "https://qa1.monstergulf.com",
        api_t_3: "https://qa1.monsterindia.com",
        site_map: "monstergulf",
        domain: "qa1.founditgulf.com",
        media_url: "media.founditgulf.com",
        region: "gulf",
        gtm_id: "GTM-TGMWFHT",
        country_code: "SA",
        country_isd_code: "966",
        country_id: "188",
        currency_code: "AED",
        currency_id: "2",
        currency_name: "Dirhams",
        currency_sign: "د.إ",
      },
      singapore: {
        api_url: "https://qa1.foundit.sg",
        api_t_1: "https://qa1.monsterindia.com",
        api_t_2: "https://qa1.monster.com.sg",
        api_t_3: "https://qa1.monsterindia.com",
        site_map: "monstersingapore",
        domain: "qa1.foundit.sg",
        media_url: "media.foundit.sg",
        region: "singapore",
        gtm_id: "GTM-WXW3G7",
        country_code: "SG",
        country_isd_code: "65",
        country_id: "25",
        currency_code: "SGD",
        currency_id: "12",
        currency_name: "Singapore Dollar",
        currency_sign: "$",
      },
      thailand: {
        api_url: "https://qa1.monster.co.th",
        api_t_1: "https://qa1.monsterindia.com",
        api_t_2: "https://qa1.monster.co.th",
        api_t_3: "https://qa1.monsterindia.com",
        site_map: "monsterthailand",
        domain: "qa1.monster.co.th",
        media_url: "media.monster.co.th",
        region: "thailand",
        gtm_id: "GTM-W4XCF74",
        country_code: "TH",
        country_isd_code: "66",
        country_id: "206",
        currency_code: "THB",
        currency_id: "15",
        currency_name: "Thai Baht",
        currency_sign: "฿",
      },
      philippines: {
        api_url: "https://qa1.foundit.com.ph",
        api_t_1: "https://qa1.monsterindia.com",
        api_t_2: "https://qa1.monster.com.ph",
        api_t_3: "https://qa1.monsterindia.com",
        site_map: "monsterphilippines",
        domain: "qa1.foundit.com.ph",
        media_url: "media.foundit.com.ph",
        region: "philippines",
        gtm_id: "GTM-NCB6SR",
        country_code: "PH",
        country_isd_code: "63",
        country_id: "172",
        currency_code: "PHP",
        currency_id: "14",
        currency_name: "Philippine Peso",
        currency_sign: "₱",
      },
      vietnam: {
        api_url: "https://qa1.monster.com.vn",
        api_t_1: "https://qa1.monsterindia.com",
        api_t_2: "https://qa1.monster.com.vn",
        api_t_3: "https://qa1.monsterindia.com",
        site_map: "monstervietnam",
        domain: "qa1.monster.com.vn",
        media_url: "media.monster.com.vn",
        region: "vietnam",
        gtm_id: "GTM-TJ7F7ZH",
        country_code: "VN",
        country_isd_code: "84",
        country_id: "222",
        currency_code: "VND",
        currency_id: "16",
        currency_name: "Vietnamese Dong",
        currency_sign: "₫",
      },
      malaysia: {
        api_url: "https://qa1.foundit.my",
        api_t_1: "https://qa1.monsterindia.com",
        api_t_2: "https://qa1.monster.com.my",
        api_t_3: "https://qa1.monsterindia.com",
        site_map: "monstermalaysia",
        domain: "qa1.foundit.my",
        media_url: "media.foundit.my",
        region: "malaysia",
        gtm_id: "GTM-57CQ4N",
        country_code: "MY",
        country_isd_code: "60",
        country_id: "136",
        currency_code: "MYR",
        currency_id: "18",
        currency_name: "Ringgit",
        currency_sign: "RM",
      },
      indonesia: {
        api_url: "https://qa1.foundit.id",
        api_t_1: "https://qa1.monsterindia.com",
        api_t_2: "https://qa1.monster.co.id",
        api_t_3: "https://qa1.monsterindia.com",
        site_map: "monsterindonesia",
        domain: "qa1.foundit.id",
        media_url: "media.foundit.id",
        region: "indonesia",
        gtm_id: "GTM-MGZV4PL",
        country_code: "ID",
        country_isd_code: "62",
        country_id: "111",
        currency_code: "IDR",
        currency_id: "13",
        currency_name: "Indonesian Rupiah",
        currency_sign: "Rp",
      },
      hongkong: {
        api_url: "https://qa1.foundit.hk",
        api_t_1: "https://qa1.monsterindia.com",
        api_t_2: "https://qa1.monster.com.hk",
        api_t_3: "https://qa1.monsterindia.com",
        site_map: "monsterhongkong",
        domain: "qa1.foundit.hk",
        media_url: "media.foundit.hk",
        region: "hongkong",
        gtm_id: "GTM-KWGPLKK",
        country_code: "HK",
        country_isd_code: "852",
        country_id: "22",
        currency_code: "HKD",
        currency_id: "11",
        currency_name: "Hong Kong Dollar",
        currency_sign: "$",
      },
    },
  },
  qa2: {
    regions: {
      india: {
        api_url: "https://qa2.foundit.in",
        api_t_1: "https://qa2.monsterindia.com",
        api_t_2: "https://qa2.monsterindia.com",
        api_t_3: "https://qa2.monsterindia.com",
        site_map: "rexmonster",
        domain: "qa1.foundit.in",
        media_url: "qa2media.foundit.in",
        region: "india",
        gtm_id: "GTM-NGL6ZM",
        country_code: "IN",
        country_isd_code: "91",
        country_id: "110",
        currency_code: "INR",
        currency_id: "4",
        currency_name: "Indian Rupees",
        currency_sign: "₹",
      },
      gulf: {
        api_url: "https://qa2.founditgulf.com",
        api_t_1: "https://qa2.monsterindia.com",
        api_t_2: "https://qa2.monstergulf.com",
        api_t_3: "https://qa2.monsterindia.com",
        site_map: "monstergulf",
        domain: "qa2.founditgulf.com",
        media_url: "media.founditgulf.com",
        region: "gulf",
        gtm_id: "GTM-TGMWFHT",
        country_code: "SA",
        country_isd_code: "966",
        country_id: "188",
        currency_code: "AED",
        currency_id: "2",
        currency_name: "Dirhams",
        currency_sign: "د.إ",
      },
      singapore: {
        api_url: "https://qa2.foundit.sg",
        api_t_1: "https://qa2.monsterindia.com",
        api_t_2: "https://qa2.monster.com.sg",
        api_t_3: "https://qa2.monsterindia.com",
        site_map: "monstersingapore",
        domain: "qa2.foundit.sg",
        media_url: "media.foundit.sg",
        region: "singapore",
        gtm_id: "GTM-WXW3G7",
        country_code: "SG",
        country_isd_code: "65",
        country_id: "25",
        currency_code: "SGD",
        currency_id: "12",
        currency_name: "Singapore Dollar",
        currency_sign: "$",
      },
      thailand: {
        api_url: "https://qa2.monster.co.th",
        api_t_1: "https://qa2.monsterindia.com",
        api_t_2: "https://qa2.monster.co.th",
        api_t_3: "https://qa2.monsterindia.com",
        site_map: "monsterthailand",
        domain: "qa2.monster.co.th",
        region: "thailand",
        gtm_id: "GTM-W4XCF74",
        country_code: "TH",
        country_isd_code: "66",
        currency_code: "THB",
        currency_id: "15",
        currency_name: "Thai Baht",
        currency_sign: "฿",
        media_url: "media.monster.co.th",
      },
      philippines: {
        api_url: "https://qa2.foundit.com.ph",
        api_t_1: "https://qa2.monsterindia.com",
        api_t_2: "https://qa2.monster.com.ph",
        api_t_3: "https://qa2.monsterindia.com",
        site_map: "monsterphilippines",
        domain: "qa2.foundit.com.ph",
        region: "philippines",
        gtm_id: "GTM-NCB6SR",
        country_code: "PH",
        country_isd_code: "63",
        country_id: "172",
        currency_code: "PHP",
        currency_id: "14",
        currency_name: "Philippine Peso",
        currency_sign: "₱",
        media_url: "media.foundit.com.ph",
      },
      vietnam: {
        api_url: "https://qa2.monster.com.vn",
        api_t_1: "https://qa2.monsterindia.com",
        api_t_2: "https://qa2.monster.com.vn",
        api_t_3: "https://qa2.monsterindia.com",
        site_map: "monstervietnam",
        domain: "qa2.monster.com.vn",
        region: "vietnam",
        gtm_id: "GTM-TJ7F7ZH",
        country_code: "VN",
        country_isd_code: "84",
        country_id: "222",
        currency_code: "VND",
        currency_id: "16",
        currency_name: "Vietnamese Dong",
        currency_sign: "₫",
        media_url: "media.monster.com.vn",
      },
      malaysia: {
        api_url: "https://qa2.foundit.my",
        api_t_1: "https://qa2.monsterindia.com",
        api_t_2: "https://qa2.monster.com.my",
        api_t_3: "https://qa2.monsterindia.com",
        site_map: "monstermalaysia",
        domain: "qa2.foundit.my",
        region: "malaysia",
        gtm_id: "GTM-57CQ4N",
        country_code: "MY",
        country_isd_code: "60",
        country_id: "136",
        currency_code: "MYR",
        currency_id: "18",
        currency_name: "Ringgit",
        currency_sign: "RM",
        media_url: "media.foundit.my",
      },
      indonesia: {
        api_url: "https://qa2.foundit.id",
        api_t_1: "https://qa2.monsterindia.com",
        api_t_2: "https://qa2.monster.co.id",
        api_t_3: "https://qa2.monsterindia.com",
        site_map: "monsterindonesia",
        domain: "qa2.foundit.id",
        region: "indonesia",
        gtm_id: "GTM-MGZV4PL",
        country_code: "ID",
        country_isd_code: "62",
        country_id: "111",
        currency_code: "IDR",
        currency_id: "13",
        currency_name: "Indonesian Rupiah",
        currency_sign: "Rp",
        media_url: "media.foundit.id",
      },
      hongkong: {
        api_url: "https://qa2.foundit.hk",
        api_t_1: "https://qa2.monsterindia.com",
        api_t_2: "https://qa2.monster.com.hk",
        api_t_3: "https://qa2.monsterindia.com",
        site_map: "monsterhongkong",
        domain: "qa2.foundit.hk",
        region: "hongkong",
        gtm_id: "GTM-KWGPLKK",
        country_code: "HK",
        country_isd_code: "852",
        country_id: "22",
        currency_code: "HKD",
        currency_id: "11",
        currency_name: "Hong Kong Dollar",
        currency_sign: "$",
        media_url: "media.foundit.hk",
      },
    },
  },
  rfs: {
    regions: {
      india: {
        api_url: "https://rfs.foundit.in",
        api_t_1: "https://rfs.monsterindia.com",
        api_t_2: "https://rfs.monsterindia.com",
        api_t_3: "https://rfs.monsterindia.com",
        site_map: "rexmonster",
        domain: "rfs.foundit.in",
        media_url: "media.foundit.in",
        region: "india",
        gtm_id: "GTM-NGL6ZM",
        country_code: "IN",
        country_isd_code: "91",
        country_id: "110",
        currency_code: "INR",
        currency_id: "4",
        currency_name: "Indian Rupees",
        currency_sign: "₹",
      },
      gulf: {
        api_url: "https://rfs.founditgulf.com",
        api_t_1: "https://rfs.monsterindia.com",
        api_t_2: "https://rfs.monstergulf.com",
        api_t_3: "https://rfs.monsterindia.com",
        site_map: "monstergulf",
        domain: "rfs.founditgulf.com",
        media_url: "media.founditgulf.com",
        region: "gulf",
        gtm_id: "GTM-TGMWFHT",
        country_code: "SA",
        country_isd_code: "966",
        country_id: "188",
        currency_code: "AED",
        currency_id: "2",
        currency_name: "Dirhams",
        currency_sign: "د.إ",
      },
      singapore: {
        api_url: "https://rfs.foundit.sg",
        api_t_1: "https://rfs.monsterindia.com",
        api_t_2: "https://rfs.monster.com.sg",
        api_t_3: "https://rfs.monsterindia.com",
        site_map: "monstersingapore",
        domain: "rfs.foundit.sg",
        media_url: "media.foundit.sg",
        region: "singapore",
        gtm_id: "GTM-WXW3G7",
        country_code: "SG",
        country_isd_code: "65",
        country_id: "25",
        currency_code: "SGD",
        currency_id: "12",
        currency_name: "Singapore Dollar",
        currency_sign: "$",
      },
      thailand: {
        api_url: "https://rfs.monster.co.th",
        api_t_1: "https://rfs.monsterindia.com",
        api_t_2: "https://rfs.monster.co.th",
        api_t_3: "https://rfs.monsterindia.com",
        site_map: "monsterthailand",
        domain: "rfs.monster.co.th",
        region: "thailand",
        gtm_id: "GTM-W4XCF74",
        country_code: "TH",
        country_isd_code: "66",
        currency_code: "THB",
        currency_id: "15",
        currency_name: "Thai Baht",
        currency_sign: "฿",
        media_url: "media.monster.co.th",
      },
      philippines: {
        api_url: "https://rfs.foundit.com.ph",
        api_t_1: "https://rfs.monsterindia.com",
        api_t_2: "https://rfs.monster.com.ph",
        api_t_3: "https://rfs.monsterindia.com",
        site_map: "monsterphilippines",
        domain: "rfs.foundit.com.ph",
        region: "philippines",
        gtm_id: "GTM-NCB6SR",
        country_code: "PH",
        country_isd_code: "63",
        country_id: "172",
        currency_code: "PHP",
        currency_id: "14",
        currency_name: "Philippine Peso",
        currency_sign: "₱",
        media_url: "media.foundit.com.ph",
      },
      vietnam: {
        api_url: "https://rfs.monster.com.vn",
        api_t_1: "https://rfs.monsterindia.com",
        api_t_2: "https://rfs.monster.com.vn",
        api_t_3: "https://rfs.monsterindia.com",
        site_map: "monstervietnam",
        domain: "rfs.monster.com.vn",
        region: "vietnam",
        gtm_id: "GTM-TJ7F7ZH",
        country_code: "VN",
        country_isd_code: "84",
        country_id: "222",
        currency_code: "VND",
        currency_id: "16",
        currency_name: "Vietnamese Dong",
        currency_sign: "₫",
        media_url: "media.monster.com.vn",
      },
      malaysia: {
        api_url: "https://rfs.foundit.my",
        api_t_1: "https://rfs.monsterindia.com",
        api_t_2: "https://rfs.monster.com.my",
        api_t_3: "https://rfs.monsterindia.com",
        site_map: "monstermalaysia",
        domain: "rfs.foundit.my",
        region: "malaysia",
        gtm_id: "GTM-57CQ4N",
        country_code: "MY",
        country_isd_code: "60",
        country_id: "136",
        currency_code: "MYR",
        currency_id: "18",
        currency_name: "Ringgit",
        currency_sign: "RM",
        media_url: "media.foundit.my",
      },
      indonesia: {
        api_url: "https://rfs.foundit.id",
        api_t_1: "https://rfs.monsterindia.com",
        api_t_2: "https://rfs.monster.co.id",
        api_t_3: "https://rfs.monsterindia.com",
        site_map: "monsterindonesia",
        domain: "rfs.foundit.id",
        region: "indonesia",
        gtm_id: "GTM-MGZV4PL",
        country_code: "ID",
        country_isd_code: "62",
        country_id: "111",
        currency_code: "IDR",
        currency_id: "13",
        currency_name: "Indonesian Rupiah",
        currency_sign: "Rp",
        media_url: "media.foundit.id",
      },
      hongkong: {
        api_url: "https://rfs.foundit.hk",
        api_t_1: "https://rfs.monsterindia.com",
        api_t_2: "https://rfs.monster.com.hk",
        api_t_3: "https://rfs.monsterindia.com",
        site_map: "monsterhongkong",
        domain: "rfs.foundit.hk",
        region: "hongkong",
        gtm_id: "GTM-KWGPLKK",
        country_code: "HK",
        country_isd_code: "852",
        country_id: "22",
        currency_code: "HKD",
        currency_id: "11",
        currency_name: "Hong Kong Dollar",
        currency_sign: "$",
        media_url: "media.foundit.hk",
      },
    },
  },
  prod: {
    regions: {
      india: {
        api_url: "https://www.foundit.in",
        api_t_1: "https://backendservices.monsterindia.com",
        api_t_2: "https://apiv2.monsterindia.com",
        api_t_3: "https://bservices.monsterindia.com",
        site_map: "rexmonster",
        domain: "www.foundit.in",
        media_url: "media.foundit.in",
        region: "india",
        gtm_id: "GTM-NGL6ZM",
        pixel_gtm_id: "AW-951240071",
        country_code: "IN",
        country_isd_code: "91",
        country_id: "110",
        currency_code: "INR",
        currency_id: "4",
        currency_name: "Indian Rupees",
        currency_sign: "₹",
      },
      gulf: {
        api_url: "https://www.founditgulf.com",
        api_t_1: "https://backendservices.monsterindia.com",
        api_t_2: "https://apiv2.monsterindia.com",
        api_t_3: "https://bservices.monsterindia.com",
        site_map: "monstergulf",
        domain: "www.founditgulf.com",
        media_url: "media.founditgulf.com",
        region: "gulf",
        gtm_id: "GTM-TGMWFHT",
        country_code: "SA",
        country_isd_code: "966",
        country_id: "188",
        currency_code: "AED",
        currency_id: "2",
        currency_name: "Dirhams",
        currency_sign: "د.إ",
      },
      singapore: {
        api_url: "https://www.foundit.sg",
        api_t_1: "https://backendservices.monsterindia.com",
        api_t_2: "https://apiv2.monsterindia.com",
        api_t_3: "https://bservices.monsterindia.com",
        site_map: "monstersingapore",
        domain: "www.foundit.sg",
        media_url: "media.foundit.sg",
        region: "singapore",
        gtm_id: "GTM-WXW3G7",
        pixel_gtm_id: "AW-623555676",
        country_code: "SG",
        country_isd_code: "65",
        country_id: "25",
        currency_code: "SGD",
        currency_id: "12",
        currency_name: "Singapore Dollar",
        currency_sign: "$",
      },
      thailand: {
        api_url: "https://www.monster.co.th",
        api_t_1: "https://backendservices.monsterindia.com",
        api_t_2: "https://apiv2.monsterindia.com",
        api_t_3: "https://bservices.monsterindia.com",
        site_map: "monsterthailand",
        domain: "www.monster.co.th",
        region: "thailand",
        gtm_id: "GTM-W4XCF74",
        country_code: "TH",
        country_isd_code: "66",
        currency_code: "THB",
        currency_id: "15",
        currency_name: "Thai Baht",
        currency_sign: "฿",
        media_url: "media.monster.co.th",
      },
      philippines: {
        api_url: "https://www.foundit.com.ph",
        api_t_1: "https://backendservices.monsterindia.com",
        api_t_2: "https://apiv2.monsterindia.com",
        api_t_3: "https://bservices.monsterindia.com",
        site_map: "monsterphilippines",
        domain: "www.foundit.com.ph",
        region: "philippines",
        gtm_id: "GTM-NCB6SR",
        pixel_gtm_id: "AW-17756203771",
        country_code: "PH",
        country_isd_code: "63",
        country_id: "172",
        currency_code: "PHP",
        currency_id: "14",
        currency_name: "Philippine Peso",
        currency_sign: "₱",
        media_url: "media.foundit.com.ph",
      },
      vietnam: {
        api_url: "https://www.monster.com.vn",
        api_t_1: "https://backendservices.monsterindia.com",
        api_t_2: "https://apiv2.monsterindia.com",
        api_t_3: "https://bservices.monsterindia.com",
        site_map: "monstervietnam",
        domain: "www.monster.com.vn",
        region: "vietnam",
        gtm_id: "GTM-TJ7F7ZH",
        country_code: "VN",
        country_isd_code: "84",
        country_id: "222",
        currency_code: "VND",
        currency_id: "16",
        currency_name: "Vietnamese Dong",
        currency_sign: "₫",
        media_url: "media.monster.com.vn",
      },
      malaysia: {
        api_url: "https://www.foundit.my",
        api_t_1: "https://backendservices.monsterindia.com",
        api_t_2: "https://apiv2.monsterindia.com",
        api_t_3: "https://bservices.monsterindia.com",
        site_map: "monstermalaysia",
        domain: "www.foundit.my",
        region: "malaysia",
        gtm_id: "GTM-57CQ4N",
        pixel_gtm_id: "AW-991453065",
        country_code: "MY",
        country_isd_code: "60",
        country_id: "136",
        currency_code: "MYR",
        currency_id: "18",
        currency_name: "Ringgit",
        currency_sign: "RM",
        media_url: "media.foundit.my",
      },
      indonesia: {
        api_url: "https://www.foundit.id",
        api_t_1: "https://backendservices.monsterindia.com",
        api_t_2: "https://apiv2.monsterindia.com",
        api_t_3: "https://bservices.monsterindia.com",
        site_map: "monsterindonesia",
        domain: "www.foundit.id",
        region: "indonesia",
        gtm_id: "GTM-MGZV4PL",
        country_code: "ID",
        country_isd_code: "62",
        country_id: "111",
        currency_code: "IDR",
        currency_id: "13",
        currency_name: "Indonesian Rupiah",
        currency_sign: "Rp",
        media_url: "media.foundit.id",
      },
      hongkong: {
        api_url: "https://www.foundit.hk",
        api_t_1: "https://backendservices.monsterindia.com",
        api_t_2: "https://apiv2.monsterindia.com",
        api_t_3: "https://bservices.monsterindia.com",
        site_map: "monsterhongkong",
        domain: "www.foundit.hk",
        region: "hongkong",
        gtm_id: "GTM-KWGPLKK",
        country_code: "HK",
        country_isd_code: "852",
        country_id: "22",
        currency_code: "HKD",
        currency_id: "11",
        currency_name: "Hong Kong Dollar",
        currency_sign: "$",
        media_url: "media.foundit.hk",
      },
    },
  },
  local: {
    regions: {
      india: {
        api_url: "https://qa1.foundit.in",
        api_t_1: "https://qa1.monsterindia.com",
        api_t_2: "https://qa1.monsterindia.com",
        api_t_3: "https://qa1.monsterindia.com",
        site_map: "rexmonster",
        domain: "qa1.foundit.in",
        media_url: "media.foundit.in",
        region: "india",
        gtm_id: "GTM-NGL6ZM",
        country_code: "IN",
        country_isd_code: "91",
        country_id: "110",
        currency_code: "INR",
        currency_id: "4",
        currency_name: "Indian Rupees",
        currency_sign: "₹",
      },
      gulf: {
        api_url: "https://qa1.founditgulf.com",
        api_t_1: "https://qa1.monsterindia.com",
        api_t_2: "https://qa1.monstergulf.com",
        api_t_3: "https://qa1.monsterindia.com",
        site_map: "monstergulf",
        domain: "qa1.founditgulf.com",
        media_url: "media.founditgulf.com",
        region: "gulf",
        gtm_id: "GTM-TGMWFHT",
        country_code: "SA",
        country_isd_code: "966",
        country_id: "188",
        currency_code: "AED",
        currency_id: "2",
        currency_name: "Dirhams",
        currency_sign: "د.إ",
      },
      singapore: {
        api_url: "https://qa1.foundit.sg",
        api_t_1: "https://qa1.monsterindia.com",
        api_t_2: "https://qa1.monster.com.sg",
        api_t_3: "https://qa1.monsterindia.com",
        site_map: "monstersingapore",
        domain: "qa1.foundit.sg",
        media_url: "media.foundit.sg",
        region: "singapore",
        gtm_id: "GTM-WXW3G7",
        country_code: "SG",
        country_isd_code: "65",
        country_id: "25",
        currency_code: "SGD",
        currency_id: "12",
        currency_name: "Singapore Dollar",
        currency_sign: "$",
      },
      thailand: {
        api_url: "https://qa1.monster.co.th",
        api_t_1: "https://qa1.monsterindia.com",
        api_t_2: "https://qa1.monster.co.th",
        api_t_3: "https://qa1.monsterindia.com",
        site_map: "monsterthailand",
        domain: "qa1.monster.co.th",
        media_url: "media.monster.co.th",
        region: "thailand",
        gtm_id: "GTM-W4XCF74",
        country_code: "TH",
        country_isd_code: "66",
        currency_code: "THB",
        currency_id: "15",
        currency_name: "Thai Baht",
        currency_sign: "฿",
      },
      philippines: {
        api_url: "https://qa1.foundit.com.ph",
        api_t_1: "https://qa1.monsterindia.com",
        api_t_2: "https://qa1.monster.com.ph",
        api_t_3: "https://qa1.monsterindia.com",
        site_map: "monsterphilippines",
        domain: "qa1.foundit.com.ph",
        media_url: "media.foundit.com.ph",
        region: "philippines",
        gtm_id: "GTM-NCB6SR",
        country_code: "PH",
        country_isd_code: "63",
        country_id: "172",
        currency_code: "PHP",
        currency_id: "14",
        currency_name: "Philippine Peso",
        currency_sign: "₱",
      },
      vietnam: {
        api_url: "https://qa1.monster.com.vn",
        api_t_1: "https://qa1.monsterindia.com",
        api_t_2: "https://qa1.monster.com.vn",
        api_t_3: "https://qa1.monsterindia.com",
        site_map: "monstervietnam",
        domain: "qa1.monster.com.vn",
        media_url: "media.monster.com.vn",
        region: "vietnam",
        gtm_id: "GTM-TJ7F7ZH",
        country_code: "VN",
        country_isd_code: "84",
        country_id: "222",
        currency_code: "VND",
        currency_id: "16",
        currency_name: "Vietnamese Dong",
        currency_sign: "₫",
      },
      malaysia: {
        api_url: "https://qa1.foundit.my",
        api_t_1: "https://qa1.monsterindia.com",
        api_t_2: "https://qa1.monster.com.my",
        api_t_3: "https://qa1.monsterindia.com",
        site_map: "monstermalaysia",
        domain: "qa1.foundit.my",
        media_url: "media.foundit.my",
        region: "malaysia",
        gtm_id: "GTM-57CQ4N",
        country_code: "MY",
        country_isd_code: "60",
        country_id: "136",
        currency_code: "MYR",
        currency_id: "18",
        currency_name: "Ringgit",
        currency_sign: "RM",
      },
      indonesia: {
        api_url: "https://qa1.foundit.id",
        api_t_1: "https://qa1.monsterindia.com",
        api_t_2: "https://qa1.monster.co.id",
        api_t_3: "https://qa1.monsterindia.com",
        site_map: "monsterindonesia",
        domain: "qa1.foundit.id",
        media_url: "media.foundit.id",
        region: "indonesia",
        gtm_id: "GTM-MGZV4PL",
        country_code: "ID",
        country_isd_code: "62",
        country_id: "111",
        currency_code: "IDR",
        currency_id: "13",
        currency_name: "Indonesian Rupiah",
        currency_sign: "Rp",
      },
      hongkong: {
        api_url: "https://qa1.foundit.hk",
        api_t_1: "https://qa1.monsterindia.com",
        api_t_2: "https://qa1.monster.com.hk",
        api_t_3: "https://qa1.monsterindia.com",
        site_map: "monsterhongkong",
        domain: "qa1.foundit.hk",
        media_url: "media.foundit.hk",
        region: "hongkong",
        gtm_id: "GTM-KWGPLKK",
        country_code: "HK",
        country_isd_code: "852",
        country_id: "22",
        currency_code: "HKD",
        currency_id: "11",
        currency_name: "Hong Kong Dollar",
        currency_sign: "$",
      },
    },
  },
};

export const REGION = {
  "foundit.in": "india",
  "founditgulf.com": "gulf",
  "foundit.sg": "singapore",
  "monster.co.th": "thailand",
  "foundit.com.ph": "philippines",
  "monster.com.vn": "vietnam",
  "foundit.my": "malaysia",
  "foundit.id": "indonesia",
  "foundit.hk": "hongkong",
};
